import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { trackEvent } from 'dibs-tracking';

class LinkRowItem extends Component {
    constructor(props) {
        super(props);

        this.trackClick = this.trackClick.bind(this);
    }

    trackClick() {
        const { trackingLabel } = this.props;

        const category = 'navigation';
        const action = 'footer navigation click';
        const label = trackingLabel.trim().toLowerCase();

        trackEvent({ category, action, label });
    }

    render() {
        const { styles = {}, target, href, dataTn, formattedMessage } = this.props;

        return (
            <div className={styles.item}>
                {href ? (
                    <a
                        className={styles.link}
                        target={target}
                        href={href}
                        onClick={this.trackClick}
                        data-tn={dataTn}
                        rel="noopener"
                    >
                        {formattedMessage}
                    </a>
                ) : (
                    formattedMessage
                )}
            </div>
        );
    }
}

LinkRowItem.propTypes = {
    styles: PropTypes.object,
    href: PropTypes.string,
    trackingLabel: PropTypes.string,
    target: PropTypes.string,
    dataTn: PropTypes.string,
    formattedMessage: PropTypes.element.isRequired,
};

export default LinkRowItem;
